import { Hotpoint } from '@/interfaces/admin/hotpoint'

export function getAllHotpointItemInArray(sheets: Array<any>): Array<string> {
  return sheets.map(sheet => {
    return sheet.imageHotPoints.map((point:Hotpoint) => point.text)
  }).reduce((a,b) => ([...a,...b]), [])
}
